var cachedWidth = $(window).width();
function checkWindowWidth(init) {
    if($(window).width() < 1024) {
        $('.db-card-header').addClass('isa-card-collapsed');
        $('.db-card-header').find('a > i.fal:last-child').addClass('fa-plus');
        $('.card-header-link').hide();
        $('.db-card-content').hide();
    } else {
        if(!init) {
            $('.db-card-header').removeClass('isa-card-collapsed');
            $('.card-header-link').show();
            $('.db-card-content').show();
        }
    }
}

function toggleCardContent() {
    var cardHeaderLink = $(this).children('.card-header-link');
    if($(window).width() < 1024) {
        $(this).toggleClass('isa-card-collapsed');
        if($(this).hasClass('isa-card-collapsed')) {
            $(this).find('a > i.fal:last-child').addClass('fa-plus');
            $(this).find('a > i.fal:last-child').removeClass('fa-minus');
            $(this).find('.fa-exclamation-circle').show();
            if(cardHeaderLink.length) {
                cardHeaderLink.hide();
            }
        } else {
            $(this).find('a > i.fal:last-child').removeClass('fa-plus');
            $(this).find('a > i.fal:last-child').addClass('fa-minus');
            $(this).find('.fa-exclamation-circle').hide();
            if(cardHeaderLink.length) {
                cardHeaderLink.show();
            }
        }
        $(this).next('.db-card-content').toggle();
    }
}

$(function () {
    checkWindowWidth(true);
    $('.db-card-header').on('click', toggleCardContent);
    $(window).resize(function () {
        var newWidth = $(window).width();
        if(newWidth !== cachedWidth) {
            // Only action on screen width change
            cachedWidth = newWidth;
            checkWindowWidth(false);
        }
    });
});
